import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

/** Bar-chart icon for the HomePage Assessment Center header button. */
export function AssessmentCenterIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      sx={{
        fontSize: 16,
        color: "primary.main",
        ...props.sx,
      }}
    >
      <path
        d="M1.77832 0.0107422H14.2217C14.4537 0.0106551 14.684 0.0557933 14.8984 0.144531C15.1129 0.233326 15.3075 0.364175 15.4717 0.52832C15.6358 0.692466 15.7667 0.887079 15.8555 1.10156C15.9442 1.31599 15.9893 1.54626 15.9893 1.77832V14.2217C15.9893 14.4537 15.9442 14.684 15.8555 14.8984C15.7667 15.1129 15.6358 15.3075 15.4717 15.4717C15.3075 15.6358 15.1129 15.7667 14.8984 15.8555C14.684 15.9442 14.4537 15.9893 14.2217 15.9893H1.77832C1.54626 15.9893 1.31599 15.9442 1.10156 15.8555C0.887079 15.7667 0.692466 15.6358 0.52832 15.4717C0.364175 15.3075 0.233326 15.1129 0.144531 14.8984C0.0557933 14.684 0.0106551 14.4537 0.0107422 14.2217V1.77832C0.0106551 1.54626 0.0557929 1.31599 0.144531 1.10156C0.233326 0.887079 0.364175 0.692466 0.52832 0.52832C0.692466 0.364175 0.887079 0.233326 1.10156 0.144531C1.31599 0.0557929 1.54626 0.0106551 1.77832 0.0107422ZM3.5459 12.4541H5.34375V6.21191H3.5459V12.4541ZM7.10059 12.4541H8.89941V3.5459H7.10059V12.4541ZM10.6562 12.4541H12.4551V8.87891H10.6562V12.4541Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
